import BottomBar from "./BottomBar";
import Home from "./Home";
import { RecoilRoot } from "recoil";

function App() {
  return (
    <RecoilRoot>
      <div className="flex flex-col h-full">
        <Home />
        <BottomBar />
      </div>
    </RecoilRoot>
  );
}

export default App;
